// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fb961f6d","977":"d0cd3384"}[chunkId] + ".chunk.js";
};